import { Col, Form, Row, Typography } from 'antd';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Input, Button } from 'components/ui';
import MainStyles from 'assets/styles/main.module.css';
import { COMPANY_SETTINGS_REWARDS } from '../../../../../const/translations/SalaryCompanySettings';
import {
  createRewardFamily,
  updateRewardFamily,
} from '../../../../../modules/SalaryModule/Rewards/actions';
import Styles from '../CompanySettingsManageRewardItemPage.module.css';

const REWARD_TITLE_LIMIT = 60;

const propTypes = {
  companyId: PropTypes.string.isRequired,
  familyData: PropTypes.object,
};

const ManageRewardFamilyTitle = memo(({ companyId, familyData }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const onFinish = useCallback(
    ({ title }) => {
      if (!title) return;

      if (familyData) {
        dispatch(
          updateRewardFamily({
            companyId,
            title,
            familyId: familyData.id,
          })
        );
      } else {
        dispatch(createRewardFamily({ companyId, title }));
      }
    },
    [companyId, familyData, dispatch]
  );

  return (
    <Form
      form={form}
      onFinish={onFinish}
      initialValues={{
        title: familyData?.title || '',
      }}
    >
      <Typography.Title
        className={clsx(MainStyles.heading, MainStyles.headingH1, Styles.title)}
      >
        {COMPANY_SETTINGS_REWARDS.FAMILY_PAGE_TITLE}
      </Typography.Title>

      <Row align="middle" className={Styles.row}>
        <Col xs={24}>
          <Typography.Text
            className={clsx(
              MainStyles.heading,
              MainStyles.formLabel,
              Styles.label
            )}
          >
            {COMPANY_SETTINGS_REWARDS.FAMILY_TITLE}
          </Typography.Text>
        </Col>

        <Col xs={24} lg={8}>
          <Form.Item
            name="title"
            className={Styles.inputWrap}
            rules={[
              {
                required: true,
                max: REWARD_TITLE_LIMIT,
              },
            ]}
          >
            <Input size="large" />
          </Form.Item>
        </Col>

        <Col xs={24} lg={4} className={Styles.btnWrap}>
          <Button className={Styles.btn} variant="primary" htmlType="submit">
            {COMPANY_SETTINGS_REWARDS.SAVE_BTN_TEXT}
          </Button>
        </Col>
      </Row>
    </Form>
  );
});

ManageRewardFamilyTitle.propTypes = propTypes;

export const ManageRewardFamilyTitleForm = ManageRewardFamilyTitle;
